import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {NB_AUTH_OPTIONS, NbAuthService, NbRequestPasswordComponent} from '@nebular/auth';
import {Router} from '@angular/router';
import {ConstantsService} from '../../@core/utils/constants.service';

@Component({
	selector: 'ngx-request-password',
	templateUrl: './request-password.component.html',
	styleUrls: ['./request-password.component.scss'],
})
export class RequestPasswordComponent extends NbRequestPasswordComponent {

	constructor(service: NbAuthService, @Inject(NB_AUTH_OPTIONS) options: {}, cd: ChangeDetectorRef, router: Router,
				public constantsService: ConstantsService ) {
		super(service, options, cd, router);
	}


    updateLogoURL($event) {
		$event.target.src = this.constantsService.roadcastURL;
    }
}
